export default __webpack_public_path__ + "static/media/7.780f3086.png";